import { createFileRoute } from '@tanstack/react-router'

import { MyLeaveManagementPage } from '@/features/leave/pages/MyLeaveManagementPage'

export const Route = createFileRoute('/_authenticated/leave/applications')({
  component: MyLeaveManagementPage,
})
